export default () => ({
  entities: 'statistics',
  statistics: [],
  agendas: 0,
  absent: 0,
  scheduled: 0,
  attended: 0,
  canceled: 0,
  total: 0
})



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/statistics/resources/data.js